export default "__VITE_ASSET__DEROSMC4__"